/**
 * ACORDE — Barra inferior.
 *
 * 1. Mantiene al día el contador de favoritos. El carrito ya se actualiza solo (Horizon,
 *    <cart-icon>). Los favoritos viven en el teléfono (ver acorde-favoritos.js, misma clave
 *    `acorde_favoritos`): aquí se lee esa lista y se escucha el evento `acorde:favoritos`.
 *
 * 2. Se turna con el encabezado (data-comportamiento="alternar"). No mide el scroll por su
 *    cuenta: lee el estado que Horizon ya calcula para el encabezado fijo en modo «al subir»
 *    (`data-sticky-state` de <header-component>), así los dos se mueven con la misma señal y
 *    no pueden desincronizarse.
 *      inactive → el encabezado está en su sitio natural (arriba de todo): barra visible
 *      idle     → el cliente baja y el encabezado se fue: barra visible
 *      active   → el cliente sube y el encabezado volvió: barra escondida
 *    Si el encabezado no está en ese modo, la barra se queda siempre visible.
 */
const CLAVE = 'acorde_favoritos';
const ESCONDIDA = 'acorde-barra--escondida';

function contarFavoritos() {
  try {
    const lista = JSON.parse(localStorage.getItem(CLAVE) || '[]');
    return Array.isArray(lista) ? lista.length : 0;
  } catch {
    return 0;
  }
}

class AcordeBarraInferior extends HTMLElement {
  connectedCallback() {
    this.burbuja = this.querySelector('[data-favoritos-conteo]');
    if (this.burbuja) {
      this.pintar(contarFavoritos());
      this.alCambiar = (evento) => this.pintar(evento.detail.length);
      document.addEventListener('acorde:favoritos', this.alCambiar);
    }

    if (this.dataset.comportamiento === 'alternar') this.seguirEncabezado();
  }

  disconnectedCallback() {
    if (this.alCambiar) document.removeEventListener('acorde:favoritos', this.alCambiar);
    this.observador?.disconnect();
  }

  pintar(cantidad) {
    this.burbuja.textContent = cantidad > 99 ? '99+' : String(cantidad);
    this.burbuja.hidden = cantidad === 0;
  }

  seguirEncabezado() {
    const encabezado = document.getElementById('header-component');
    if (!encabezado || encabezado.getAttribute('sticky') !== 'scroll-up') return;

    const aplicar = () => {
      this.classList.toggle(ESCONDIDA, encabezado.dataset.stickyState === 'active');
    };

    this.observador = new MutationObserver(aplicar);
    this.observador.observe(encabezado, { attributes: true, attributeFilter: ['data-sticky-state'] });
    aplicar();
  }
}

if (!customElements.get('acorde-barra-inferior')) {
  customElements.define('acorde-barra-inferior', AcordeBarraInferior);
}
